var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencilBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1979_8125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1979_8125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 24C3.45 24 2.97917 23.8041 2.5875 23.4125C2.19583 23.0208 2 22.55 2 22C2 21.45 2.19583 20.9791 2.5875 20.5875C2.97917 20.1958 3.45 20 4 20H20C20.55 20 21.0208 20.1958 21.4125 20.5875C21.8042 20.9791 22 21.45 22 22C22 22.55 21.8042 23.0208 21.4125 23.4125C21.0208 23.8041 20.55 24 20 24H4ZM5 18C4.71667 18 4.47917 17.9041 4.2875 17.7125C4.09583 17.5208 4 17.2833 4 17V14.675C4 14.5416 4.025 14.4125 4.075 14.2875C4.125 14.1625 4.2 14.05 4.3 13.95L13.05 5.19996L16.8 8.94996L8.05 17.7C7.95 17.8 7.8375 17.875 7.7125 17.925C7.5875 17.975 7.45833 18 7.325 18H5ZM6 16H6.9L14 8.94996L13.05 7.99996L6 15.1V16ZM17.925 7.84996L14.175 4.09996L15.975 2.29996C16.1583 2.09996 16.3917 2.00413 16.675 2.01246C16.9583 2.0208 17.1917 2.11663 17.375 2.29996L19.725 4.64996C19.9083 4.8333 20 5.06246 20 5.33746C20 5.61246 19.9083 5.84996 19.725 6.04996L17.925 7.84996Z",
    fill: "#2354D4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilBlue);
export default __webpack_public_path__ + "static/media/editPencilBlue.060fe75303be3ce6df62934303a01b46.svg";
export { ForwardRef as ReactComponent };